module.exports = __webpack_public_path__ + "img/cart-items-unactive.139aaaf.svg";